import { useAuth } from '@/models/auth';
import { Center } from '@mantine/core';
import { GoogleLogin } from '@react-oauth/google';

export function Auth() {
  const { signIn } = useAuth();
  return (
    <Center h="100vh">
      <GoogleLogin
        auto_select
        useOneTap
        onSuccess={(credentialResponse) =>
          signIn(credentialResponse.credential!)
        }
      />
    </Center>
  );
}
